const Chart = require('chart.js');
const utils = require('frontend-controller/lib/utils')

const COLORS = [
	'#006600',
	'#B20000',
	'#ff5900',
	'#ffdc0e',
	'#3076B2',
	'#830e9b',
	'#000000',

	'rgba(0,102,0,0.55)',
	'rgba(178,0,0,0.62)',
	'rgba(255,89,0,0.75)',
	'rgba(255,220,14,0.57)',
	'rgba(48,118,178,0.68)',
	'rgba(131,14,155,0.69)',
	'rgba(0,0,0,0.6)',

	'rgba(0,102,0,0.38)',
	'rgba(178,0,0,0.31)',
	'rgba(255,89,0,0.52)',
	'rgba(255,220,14,0.4)',
	'rgba(48,118,178,0.44)',
	'rgba(131,14,155,0.45)',
	'rgba(0,0,0,0.28)',
]

const CHART_PROPERTIES = {
	line: {
		type: 'line',
		data: [],
		options: {
			legend: {
				// display: false
				position: 'right',
			},
			tooltips: {
				enabled: true,
				callbacks: {
					afterTitle: function(tooltipItem, data) {
						const classIndex = ((tooltipItem || [])[0] || {}).index
						const classLabelDetails = (data || {}).labelDetails || {}
						if(classLabelDetails[classIndex]){
							return classLabelDetails[classIndex]
						}
						return ''
					}
				}
			},
			hover: {
				animationDuration: 0 // duration of animations when hovering an item
			},
			aspectRatio: 2,
				layout: {
				padding: {
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}
			}
		}
	},
	radar: {
		type: 'radar',
		data: [],
		options: {
			legend: {
				// display: false
				position: 'right',
			},
			tooltips: {
				enabled: true,
				// callbacks: {
				// 	afterTitle: function(tooltipItem, data) {
				// 		const classIndex = ((tooltipItem || [])[0] || {}).index
				// 		const classLabelDetails = (data || {}).labelDetails || {}
				// 		if(classLabelDetails[classIndex]){
				// 			return classLabelDetails[classIndex]
				// 		}
				// 		return ''
				// 	}
				// }
			},
			hover: {
				animationDuration: 0 // duration of animations when hovering an item
			},
			aspectRatio: 2,
			layout: {
				padding: {
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}
			}
		}
	},
}

module.exports = {
	config: {
		chartType: 'line',
		dataType: 'nrOfActions'
	},

	model: {
		chartProperties: {},
		chartAttributes: {}
	},

	methods: {
		initChart: function(){
			if(!this.model.chart && this.$.length > 0){
				this.model.chart = new Chart(this.$.find('> .canvasContainer > canvas'), this.model.chartProperties);
			}
		},

		prepareChartData: function(attributes = {}){
			const self = this
			const users = attributes.users
			const dataSets = self.model.chart.data.datasets = []
			let colorIndex = 0
			let dataSetsByProtocolUserID

			if(self.config.chartType === 'radar'){
				let labels
				if(self.config.dataType === 'methodStats'){
					labels = self.model.chart.data.labels = attributes.methods || []
					self.model.chart.data.labelDetails = attributes.methods || []
				} else {
					labels = self.model.chart.data.labels = attributes.contexts || []
					self.model.chart.data.labelDetails = attributes.contexts || []
				}
				dataSetsByProtocolUserID = attributes[self.config.dataType]

				// add one dataset per user
				for(const protocolUserID in dataSetsByProtocolUserID){
					const dataSet = {
						data: [],
						borderColor: COLORS[colorIndex++ % COLORS.length],
						backgroundColor: 'transparent'
					}
					const user = users[protocolUserID] || {}

					if(utils.isEmpty(user)) {
						dataSet.label = 'UNKOWN_USER'
					} else {
						dataSet.label = `#${user.userID} | ${user.code} | ${user.email}`
					}

					for(const classIndex in labels){
						const label = labels[classIndex]
						const value = dataSetsByProtocolUserID[protocolUserID][label]

						// add record
						dataSet.data[classIndex] = value || 0
					}

					dataSets.push(dataSet)
				}
			} else {
				self.model.chart.data.labels = attributes.classLabels || []
				self.model.chart.data.labelDetails = attributes.classLabelDetails || []
				dataSetsByProtocolUserID = attributes.stats

				// add one dataset per user
				for(const protocolUserID in dataSetsByProtocolUserID){
					const dataSet = {
						data: [],
						borderColor: COLORS[colorIndex++ % COLORS.length],
						backgroundColor: 'transparent'
					}
					const user = users[protocolUserID] || {}

					if(utils.isEmpty(user)) {
						dataSet.label = 'UNKOWN_USER'
					} else {
						dataSet.label = `#${user.userID} | ${user.code} | ${user.email}`
					}

					// add all records
					let lastClassIndex = -1
					for(const i in dataSetsByProtocolUserID[protocolUserID]){
						const record = dataSetsByProtocolUserID[protocolUserID][i] || {}
						const classIndex = record.classIndex

						// add intermediate zeros
						if(lastClassIndex < classIndex - 1){
							for(let ci = lastClassIndex + 1; ci <= classIndex; ci++){
								if(ci < classIndex){
									dataSet.data[ci] = {
										x: ci,
										y: 0,
									}
								}
							}
						}
						lastClassIndex = classIndex

						// add record
						dataSet.data[classIndex] = {
							x: classIndex,
							y: record[self.config.dataType || 'nrOfActions'] || 0,
						}
					}

					// add trailing zeros
					for(let ci = lastClassIndex + 1; ci < self.model.chart.data.labels.length; ci++){
						dataSet.data[ci] = {
							x: ci,
							y: 0,
						}
					}

					dataSets.push(dataSet)
				}
			}
		}
	},

	hooks: {
		update: function($element, options) {
			var self = this;

			self.initChart();

			const attributes = (((options || {}).resourceData || {}).data || {}).attributes || {}

			if(self.model.chart && !utils.isEmpty(attributes)){
				self.prepareChartData(attributes)
				self.model.chart.update();
			}
		},

		attach: function($element, options){
			const self = this;

			// in case of refreshes the chart-dom-binding has to be renewed
			if (self.model.chart && (options || {}).refresh){
				self.model.chart.destroy();
				delete self.model.chart;
			}
			if(!self.model.chart){
				self.model.chartProperties = utils.simpleCopy(CHART_PROPERTIES[self.config.chartType || 'line'])
				self.model.chartProperties.data = {}
				self.initChart()

				// check if controller has resources ready.
				// sometimes the controllers update trigger is a bit early and the charts are not ready yet.
				self.closest('templates_protocol_stats_controller', function(controller){
					const attributes = (((controller || {}).resourceData || {}).data || {}).attributes || {}
					if(self.model.chart && !utils.isEmpty(attributes)){
						self.prepareChartData(attributes)
						self.model.chart.update();
					}
				})
			}
		}

	}
};
